import { Component, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { HttpService } from '@core/services/http.service';
import { forkJoin, Subject } from 'rxjs';
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationService } from '../registration.service';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { modalButtonTitles, ModalConfig, modalContent, modalHeading } from '@app/shared/constants/modal.model';
import { takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ContentManagementModalComponent } from '@app/systemconfiguration/content-management/modal/content-management-modal.component';
import { LocalService } from '@app/@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-fingerprint-registration',
  templateUrl: './fingerprint-registration.component.html',
  styleUrls: ['./fingerprint-registration.component.scss']
})
export class FingerprintRegistrationComponent  implements OnInit {
  customModal: NgbModalRef;

  onDpsIdInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, '');
    value = value.substring(0, 5);
    this.fingerprintRegistrationForm.get('dpsId')?.setValue(this.normalizeSpaces(value), { emitEvent: false });
  }
   onFirstNameInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    value = this.preventBackToBackChars(value);
    this.fingerprintRegistrationForm.get('firstName')?.setValue(this.toTitleCase(value), { emitEvent: false });
  }
   onLastNameInput(event: any) {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\-' ]/g, '');
    value = value.substring(0, 30);
    value = this.preventBackToBackChars(value);
    this.fingerprintRegistrationForm.get('lastName')?.setValue(this.toTitleCase(value), { emitEvent: false });
  }

  private toTitleCase(text: string): string {
    if (!text) return '';
    return text.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
  }

  onOrganizationInput(event: any) {
    let value = event.target.value;
    value = value.substring(0, 60);
    // Basic character filtering only
    value = value.replace(/[^A-Za-z\s\.\,\-\&\'\(\)\/]/g, '');
    // Prevent leading spaces and back-to-back characters
    value = this.preventBackToBackChars(value);
    this.fingerprintRegistrationForm.get('organization')?.setValue(value, { emitEvent: false });
    // Check for special character at end
    this.checkForSpecialCharAtEnd('organization');
  }

  ondepartmentInput(event: any) {
    let value = event.target.value;
    value = value.substring(0, 60);
    // Basic character filtering only
    value = value.replace(/[^A-Za-z\s\.\,\-\&\'\(\)\/]/g, '');
    // Prevent leading spaces and back-to-back characters
    value = this.preventBackToBackChars(value);
    this.fingerprintRegistrationForm.get('department')?.setValue(value, { emitEvent: false });
    this.checkForSpecialCharAtEnd('department');
  }

  onTitleInput(event: any) {
    let value = event.target.value;
    value = value.substring(0, 60);
    // Basic character filtering only
    value = value.replace(/[^A-Za-z\s\.\,\-\&\'\(\)\/]/g, '');
    // Prevent leading spaces and back-to-back characters
    value = this.preventBackToBackChars(value);
    this.fingerprintRegistrationForm.get('title')?.setValue(value, { emitEvent: false });
    this.checkForSpecialCharAtEnd('title');
  }

onStreetAddressInput(event: any) {
  let value = event.target.value;
  // Allow A-Z, a-z, 0-9, space, period, comma, hyphen, apostrophe, number sign, forward slash
  value = value.replace(/[^A-Za-z0-9\s\.\,\-\'\#\/]/g, '');
  value = value.substring(0, 60);
  // Prevent leading spaces and back-to-back characters
  value = this.preventBackToBackChars(value);
  this.fingerprintRegistrationForm.get('streetAddress')?.setValue(value, { emitEvent: false });
  this.checkForSpecialCharAtEnd('streetAddress');
}

  onExtensionInput(event: any) {
    let value = event.target.value;
    // Only allow numbers
    value = value.replace(/[^0-9]/g, '');
    // Limit to 10 digits
    value = value.substring(0, 10);
    this.fingerprintRegistrationForm.get('extension')?.setValue(value, { emitEvent: false });
  }



  // Clean up fields when user leaves them (blur event)
  onFieldBlur(event: any, controlName: string) {
    let value = event.target.value;
    // Only trim spaces - allow all permitted special characters at start and end
    value = value.trim();
    // No longer remove special characters from start/end since they are allowed per requirements
    // All these characters are permitted: . , - & ' ( ) /
    // For street address: . , - ' # / are also allowed
    this.fingerprintRegistrationForm.get(controlName)?.setValue(value, { emitEvent: false });

    // Check for special characters at the end of field
    this.checkForSpecialCharAtEnd(controlName);
  }

  normalizeSpaces(value: string) {
  value = value.replace(/\s+/g, ' ');
  return value;
}

  checkForSpecialCharAtEnd(controlName: string) {
    const fieldsToCheck = ['organization', 'title', 'department', 'streetAddress'];
    if (!fieldsToCheck.includes(controlName)) return;

    const value = this.fingerprintRegistrationForm.get(controlName)?.value;
    if (!value) return;

    // Define special characters based on field type
    let specialCharsPattern;
    if (controlName === 'streetAddress') {
      specialCharsPattern = /[.,\-'#\/]$/; // For street address
    } else {
      specialCharsPattern = /[.,\-&'()\/]$/; // For organization, title, department
    }

    // Check if the field ends with a special character
    const endsWithSpecialChar = specialCharsPattern.test(value);

    if (endsWithSpecialChar) {
      this.fingerprintRegistrationForm.get(controlName)?.setErrors({
        ...this.fingerprintRegistrationForm.get(controlName)?.errors,
        specialCharAtEnd: true
      });
    } else {
      // Remove the special character error if it exists
      const errors = this.fingerprintRegistrationForm.get(controlName)?.errors;
      if (errors && errors['specialCharAtEnd']) {
        delete errors['specialCharAtEnd'];
        if (Object.keys(errors).length === 0) {
          this.fingerprintRegistrationForm.get(controlName)?.setErrors(null);
        } else {
          this.fingerprintRegistrationForm.get(controlName)?.setErrors(errors);
        }
      }
    }
  }

preventLeadingSpaces(value: string): string {
  // Remove leading spaces but allow spaces between characters
  value = value.replace(/^\s+/, '');
  // Replace multiple spaces with single space
  value = value.replace(/\s+/g, ' ');
  // Prevent back-to-back punctuations (.,&'()-/)
  value = value.replace(/[.,&'()\/\-]{2,}/g, (match) => match[0]);
  // Prevent back-to-back apostrophes specifically
  value = value.replace(/'{2,}/g, "'");
  return value;
}

preventBackToBackChars(value: string): string {
  // Remove leading spaces
  value = value.replace(/^\s+/, '');
  // Replace multiple consecutive spaces with single space
  value = value.replace(/\s{2,}/g, ' ');
  // Prevent back-to-back punctuations: period, comma, hyphen, ampersand, parentheses, forward slash, number sign
  value = value.replace(/[.]{2,}/g, '.');
  value = value.replace(/[,]{2,}/g, ',');
  value = value.replace(/[-]{2,}/g, '-');
  value = value.replace(/[&]{2,}/g, '&');
  value = value.replace(/[']{2,}/g, "'");
  value = value.replace(/[\(]{2,}/g, '(');
  value = value.replace(/[\)]{2,}/g, ')');
  value = value.replace(/[\/]{2,}/g, '/');
  value = value.replace(/[#]{2,}/g, '#');


  value = value.replace(/([.,\-&'()\/#])\1+/g, '$1');

  while (/[.,\-&'()\/#][.,\-&'()\/#]/.test(value)) {
    value = value.replace(/([.,\-&'()\/#])([.,\-&'()\/#])/, '$1');
  }

  return value;
}
checkForTrailingSpace(event: any, controlName: string) {
  let value = event.target.value;
  this.fingerprintRegistrationForm.get(controlName)?.setValue(value.trimEnd(), { emitEvent: false });
}

validateSpecialCharsAtEdges(value: string): string {
  // First replace multiple spaces with single spaces
  value = value.replace(/\s+/g, ' ');
  // Then trim any leading/trailing spaces
  value = value.trim();
  // Remove punctuation and apostrophes from beginning
  value = value.replace(/^[.,\/#!$%\^&\*;:{}=\-_`~()']+/, '');
  // Remove punctuation and apostrophes from end
  value = value.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()']+$/, '');
  return value;
}

validateGeneralTextbox(value: string): string {
  // Allow A-Z, a-z, space, period, comma, hyphen, ampersand, apostrophe, parentheses, forward slash
  value = value.replace(/[^A-Za-z\s\.\,\-\&\'\(\)\/]/g, '');
  // Prevent consecutive spaces
  value = value.replace(/\s+/g, ' ');
  // Prevent back-to-back punctuations (but allow while typing)
  value = value.replace(/[.,\-&'()\/]{3,}/g, (match) => match.substring(0, 2));
  return value;
}
  fingerprintRegistrationForm: FormGroup;
  errorMessages: any[] = [];
  toastMessages: any[] = [];
  genericMessages: any[] = [];
  placeholderMessages: any[] = [];
  userAgreementContent: string = '';
  modalRef: NgbModalRef;
  closeResult = '';
  currentDate: string = new Date().toISOString().split('T')[0];
  errorMessage: any = {};
  toastMessage: any = {};
  genericMessage: any = {};
  placeholderMessage: any = {};
  dspIdTooltip: boolean = false;
  showModal: boolean = false;
  // duplicateDpsId: boolean = false;
  // duplicatePhoneNumber: boolean = false;
  private destroy$ = new Subject<void>();
  emailFromUrl: string = '';

    constructor(
      private readonly fb: FormBuilder,
      private readonly router: Router,
      private readonly httpService: HttpService,
      private readonly ngModal: NgbModal,
      private readonly registrationService: RegistrationService,
      private readonly route: ActivatedRoute,
      private readonly localstorage: LocalService,
      private readonly matDialog: MatDialog

    ) {}
  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.emailFromUrl = params['email'] || '';
        this.createForm();
        if (this.emailFromUrl) {
          this.registrationService.getUserDetailsByEmail(this.emailFromUrl)
            .pipe(takeUntil(this.destroy$))
            .subscribe((user: any) => {
              if (user?.data?.data) {
                this.fingerprintRegistrationForm.patchValue({
                  firstName: user.data.data.firstname || '',
                  lastName: user.data.data.lastname || '',
                  organization: user.data.data.additional_fields?.organization || ''
                });
                ['firstName', 'lastName', 'organization'].forEach(field => {
                  const control = this.fingerprintRegistrationForm.get(field);
                  if (control?.invalid) {
                    control.markAsTouched();
                  }
                });
              }
              this.loadDropdownData();
            }, () => {
              this.loadDropdownData();
            });
        } else {
          this.loadDropdownData();
        }
      });
  }
  private async loadDropdownData() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=PLACEHOLDER MESSAGES'),
      this.registrationService.getUserAgreementContent(500, '2', 'FPV'),
    ]).subscribe({
      next: (item: any) => {
        this.errorMessages = item[0].data;
        this.toastMessages = item[1].data;
        this.genericMessages = item[2].data;
        this.placeholderMessages = item[3].data;
        this.errorMessage = {};
        this.errorMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.errorMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('errorMessages', JSON.stringify(this.errorMessages));

        // Process toast messages
        this.toastMessage = {};
        this.toastMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.toastMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('toastMessages', JSON.stringify(this.toastMessages));

        // Process generic messages
        this.genericMessage = {};
        this.genericMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.genericMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('genericMessages', JSON.stringify(this.genericMessages));

        // Process placeholder messages
        this.placeholderMessage = {};
        this.placeholderMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.placeholderMessage[message.key] = message.value;
          }
        });
        window.localStorage.setItem('placeholderMessages', JSON.stringify(this.placeholderMessages));

        // Store user agreement content from lookup
        if (item[4]?.data?.length > 0) {
          const optionalData = item[4].data[0].optionaldata;
          if (optionalData) {
            try {
              const parsed = typeof optionalData === 'string' ? JSON.parse(optionalData) : optionalData;
              this.userAgreementContent = parsed?.content || '';
            } catch {
              this.userAgreementContent = optionalData;
            }
          }
        }

      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
  }
  createForm(user?: any) {
    this.fingerprintRegistrationForm = this.fb.group({
      email: [this.emailFromUrl, ],
      firstName: [
      user?.firstname || '',
      [
        Validators.required,
        Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
        Validators.minLength(2),
        Validators.maxLength(30)
      ]
      ],
       lastName: [
      user?.lastname || '',
      [
      Validators.required,
      Validators.pattern("^[A-Za-z]+([-' ][A-Za-z]+)*\\s*$"),
      Validators.minLength(2),
      Validators.maxLength(30)
      ]
      ],
       dpsId: [
      '',
      [
        Validators.required,
        Validators.pattern("^[0-9]{5}$"),
        (control) => control.value === '00000' ? { invalidDpsId: true } : null
      ]
      ],
       organization: [
      user?.organization || '',
      [
        Validators.required,
        Validators.pattern("^[A-Za-z][A-Za-z\\s.,\\-&'()\\/]*$"),
        Validators.minLength(2),
        Validators.maxLength(60)
      ]
      ],
       department: [
        '',
        [
          Validators.pattern("^[A-Za-z][A-Za-z\\s.,\\-&'()\\/]*$"),
          Validators.minLength(2),
          Validators.maxLength(60)
        ]
      ],
       title: [
        '',
        [
          Validators.pattern("^[A-Za-z][A-Za-z\\s.,\\-&'()\\/]*$"),
          Validators.minLength(2),
          Validators.maxLength(60)
        ]
      ],
        zipCode: ['',
        [
          Validators.required,
          Validators.pattern('^\\d{5}(|-\\d{4})$'),  // Either 5 digits or 5 digits followed by hyphen and 4 digits
          Validators.minLength(5),
          Validators.maxLength(10)
        ]
        ],
      city: [
        '',
        [
          Validators.pattern("^[A-Za-z\\s'-]{2,60}$"),
          Validators.minLength(2),
          Validators.maxLength(60)
        ]
      ],
      state: [
        'Nevada',
        [
          Validators.pattern("^[A-Za-z\\s'-]{2,60}$"),
          Validators.minLength(2),
          Validators.maxLength(60)
        ]
      ],
     streetAddress: ['',
      [
          Validators.required,
          Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s.,\\-'/#]*$"),
          Validators.minLength(3),
          Validators.maxLength(60)
      ]
      ],
      phoneNumber: [
      '',
        [
    Validators.required,
    Validators.pattern('^(\\+1 )?\\(\\d{3}\\) \\d{3}-\\d{4}$'),
    Validators.maxLength(17)
        ]
      ],
      extension: [
        '',
        [Validators.pattern('^\\d{1,10}$'),
         Validators.minLength(2),
         Validators.maxLength(10)
      ]
    ],
      terms: [false, Validators.requiredTrue],
      consent:[false, Validators.requiredTrue]
    },  { validators: this.cityStateRequiredIfZipValid });
  }

  cityStateRequiredIfZipValid(form: FormGroup) {
  const zip = form.get('zipCode')?.value || '';
  const city = form.get('city')?.value || '';
  const state = form.get('state')?.value || '';
  const zipPattern = /^\d{5}$|^\d{5}-\d{4}$/;

  if (zipPattern.test(zip) && (!city || !state)) {
    return { cityStateMissing: true };
  }
  return null;
}

  zipCodeFormat(event: any) {
    console.log("zipcode:🤳", event.target.value)
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 10) value = value.substring(0, 10);

    let formatted = value;
    if (value.length > 5 && value.length < 9) {
      this.fingerprintRegistrationForm.get('zipCode')?.setErrors({ 'invalidZipLength': true });
          this.fingerprintRegistrationForm.patchValue({
      city: '',
      state: ''
    });
    }

    if (value.length > 5) {
      formatted = ` ${value.substring(0, 5)}-${value.substring(5)}`;
    }
      if (value.length < 5) {
    this.fingerprintRegistrationForm.patchValue({
      city: '',
      state: ''
    });
  }

    if (value.length >= 5) {
      const allZerosPattern = /^0+$/;
      const isAllZeros = allZerosPattern.test(value);
      if (isAllZeros) {
        // Only force mask if not deleting
        const inputType = event.inputType || '';
        if (inputType !== 'deleteContentBackward' && inputType !== 'deleteContentForward') {
          let masked = value.length === 5 ? '00000' : '00000-0000';
          this.fingerprintRegistrationForm.get('zipCode')?.setValue(masked, { emitEvent: false });
        }
        this.fingerprintRegistrationForm.get('zipCode')?.setErrors({ 'allZeros': true });
        this.fingerprintRegistrationForm.patchValue({
          city: '',
          state: ''
        });
        return;
      }
    }
    this.fingerprintRegistrationForm.get('zipCode')?.setValue(formatted.trim(), { emitEvent: false });
      if (value.length === 5 || value.length === 9) {
    setTimeout(() => {
      this.getAddress();
    }, 100);
  }
  }

  formatPhoneNumber(event: any) {
    let input = event.target.value;
    const isDeleting = event.inputType === 'deleteContentBackward';
    // Allow empty value
    if (!input) {
      this.fingerprintRegistrationForm.get('phoneNumber')?.setValue('', { emitEvent: false });
      return;
    }
    // Block alphabetic input
    if (/[a-zA-Z]/.test(input)) {
      input = input.replace(/[a-zA-Z]/g, '');
    }
    //Auto prepend +1 only when typing (not deleting)
    if (!isDeleting && !input.startsWith('+1') && input !== '+') {
      input = '+1 ' + input.replace(/^\+/, '');
    }
    // Allow empty value
    if (!input) {
      this.fingerprintRegistrationForm.get('phoneNumber')?.setValue('', { emitEvent: false });
      return;
    }
    // If starts with '+1', enforce '+1 (XXX) XXX XXXX' format
    if (input.startsWith('+1')) {
      // Only insert space after '+1' if user is typing forward (not deleting)
      if (input.length > 2 && input[2] !== ' ') {
        // Check if last key pressed was not Backspace
        if (event.inputType !== 'deleteContentBackward') {
          input = '+1 ' + input.slice(2);
        }
      }
      let numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      // Strip repeated country code: e.g. user pasted 18XXXXXXXXX after field already had "+1 "
      if (digits.length === 11 && digits.startsWith('1')) {
        digits = digits.substring(1);
      }
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      let finalValue = input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
      this.fingerprintRegistrationForm.get('phoneNumber')?.setValue(finalValue, { emitEvent: false });
      return;
    }
    // If starts with '(', enforce '(XXX) XXX XXXX' format
    if (input.startsWith('(')) {
      let digits = input.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      this.fingerprintRegistrationForm.get('phoneNumber')?.setValue(formatted, { emitEvent: false });
      return;
    }
    // If only digits, format as '(XXX) XXX XXXX'
    if (/^\d+$/.test(input)) {
      let digits = input.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      this.fingerprintRegistrationForm.get('phoneNumber')?.setValue(formatted, { emitEvent: false });
      return;
    }
    // Allow '+', '+1', '+1 ' as valid prefixes, and allow user to delete them
    if (input === '+' || input === '+1' || input === '+1 ') {
      this.fingerprintRegistrationForm.get('phoneNumber')?.setValue(input, { emitEvent: false });
      return;
    }
    // For any other input, clear the field
    this.fingerprintRegistrationForm.get('phoneNumber')?.setValue('', { emitEvent: false });
    return;
  }

  // checkDuplicateDpsId() {
  //   const dpsId = this.fingerprintRegistrationForm.get('dpsId')?.value;
  //   if (!dpsId) return;
  //   this.registrationService.checkFpDpsIdDuplicate(dpsId).subscribe({
  //     next: (result: any) => {
  //       console.log('DPS identified', result.data.exists)
  //       this.duplicateDpsId = result?.data.exists || false;
  //       if (this.duplicateDpsId) {
  //         this.fingerprintRegistrationForm.get('dpsId')?.setErrors({ ...this.fingerprintRegistrationForm.get('dpsId')?.errors, duplicate: true });
  //       } else {
  //         const errors = this.fingerprintRegistrationForm.get('dpsId')?.errors;
  //         if (errors) {
  //           delete errors['duplicate'];
  //           if (Object.keys(errors).length === 0) {
  //             this.fingerprintRegistrationForm.get('dpsId')?.setErrors(null);
  //           } else {
  //             this.fingerprintRegistrationForm.get('dpsId')?.setErrors(errors);
  //           }
  //         }
  //       }
  //     },
  //     error: () => {
  //       this.duplicateDpsId = false;
  //     }
  //   });
  // }

  // checkDuplicatePhoneNumber() {
  //   const phoneNumberRaw = this.fingerprintRegistrationForm.get('phoneNumber')?.value;
  //   let phoneNumber = phoneNumberRaw.startsWith('+1')
  //   ? phoneNumberRaw.substring(2).replace(/\D/g, '')
  //   : phoneNumberRaw.replace(/\D/g, '');
  // console.log('Checking duplicate for phone number (normalized):', phoneNumber);
  //   if (!phoneNumber) return;
  //   this.registrationService.checkFpPhoneDuplicate(phoneNumber).subscribe({
  //     next: (result: any) => {
  //       console.log('Duplicate check API response:', result);
  //       this.duplicatePhoneNumber = result?.data.exists || false;
  //       if (this.duplicatePhoneNumber) {
  //         this.fingerprintRegistrationForm.get('phoneNumber')?.setErrors({ ...this.fingerprintRegistrationForm.get('phoneNumber')?.errors, duplicate: true });
  //       } else {
  //         const errors = this.fingerprintRegistrationForm.get('phoneNumber')?.errors;
  //         if (errors) {
  //           delete errors['duplicate'];
  //           if (Object.keys(errors).length === 0) {
  //             this.fingerprintRegistrationForm.get('phoneNumber')?.setErrors(null);
  //           } else {
  //             this.fingerprintRegistrationForm.get('phoneNumber')?.setErrors(errors);
  //           }
  //         }
  //       }
  //       console.log('Form control errors after duplicate check:', this.fingerprintRegistrationForm.get('phoneNumber')?.errors);
  //     },
  //     error: (err) => {
  //       console.error('Duplicate check API error:', err);
  //       this.duplicatePhoneNumber = false;
  //     }
  //   });
  // }

  onSubmit() {
    if (this.fingerprintRegistrationForm.valid) {
      const updatedPhoneNumber = this.fingerprintRegistrationForm.get('phoneNumber')?.value.replace(/\D/g, '').replace(/^1(\d{10})$/, '$1');
      const formData = {
        email: this.fingerprintRegistrationForm.get('email')?.value,
        first_name: this.fingerprintRegistrationForm.get('firstName')?.value,
        last_name: this.fingerprintRegistrationForm.get('lastName')?.value,
        dps_id: this.fingerprintRegistrationForm.get('dpsId')?.value,
        department: this.fingerprintRegistrationForm.get('department')?.value,
        title: this.fingerprintRegistrationForm.get('title')?.value,
        street_address: this.fingerprintRegistrationForm.get('streetAddress')?.value,
        zipcode: this.fingerprintRegistrationForm.get('zipCode')?.value,
        city: this.fingerprintRegistrationForm.get('city')?.value,
        state: this.fingerprintRegistrationForm.get('state')?.value,
        phone: updatedPhoneNumber,
        extensions: this.fingerprintRegistrationForm.get('extension')?.value,
        organization: this.fingerprintRegistrationForm.get('organization')?.value,
        is_channel: this.fingerprintRegistrationForm.get('terms')?.value,
        is_consent: this.fingerprintRegistrationForm.get('consent')?.value
      };
      this.localstorage.setItem('externalRegistrationFormData', JSON.stringify(formData))
      this.router.navigate(['/login']);
    } else {
      this.fingerprintRegistrationForm.markAllAsTouched();
      Object.keys(this.fingerprintRegistrationForm.controls).forEach(key => {
        const control = this.fingerprintRegistrationForm.get(key);
        if (control && control.invalid) {
          console.log(`Field ${key} is invalid:`, control.errors);
        }
      });
    }
  }

  validateDate(control: any) {
    const selectedDate = new Date(control.value);
    const today = new Date();

    // Reset time part to compare just the dates
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      return { 'futureDate': true };
    }

    return null;
  }
  get email() {
    return this.fingerprintRegistrationForm.get('email');
  }
  get firstName() {
    return this.fingerprintRegistrationForm.get('firstName');
  }
  get lastName() {
    return this.fingerprintRegistrationForm.get('lastName');
  }
   get dpsId() {
    return this.fingerprintRegistrationForm.get('dpsId');
  }
  get organization() {
    return this.fingerprintRegistrationForm.get('organization');
  }
  get department() {
    return this.fingerprintRegistrationForm.get('department');
  }
  get title() {
    return this.fingerprintRegistrationForm.get('title');
  }
  get streetAddress() {
    return this.fingerprintRegistrationForm.get('streetAddress');
  }
  get zipCode() {
    return this.fingerprintRegistrationForm.get('zipCode');
  }
  get city() {
    return this.fingerprintRegistrationForm.get('city');
  }
  get state() {
    return this.fingerprintRegistrationForm.get('state');
  }
  get extension() {
    return this.fingerprintRegistrationForm.get('extension');
  }
  get phoneNumber() {
    return this.fingerprintRegistrationForm.get('phoneNumber');
  }
  open(content) {
    this.ngModal.open(content, { size: 'md', backdrop: 'static' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getAddress(){

      const zipCodeValue = this.fingerprintRegistrationForm.get('zipCode')?.value || '';
  const cleanZipCode = zipCodeValue.replace(/\D/g, '');

    if (!cleanZipCode || (cleanZipCode.length !== 5 && cleanZipCode.length !== 9)) {
    this.fingerprintRegistrationForm.patchValue({
      city: '',
      state: ''
    });
    return;
  }
  const allZerosPattern = /^0+$/;
  const isAllZeros = allZerosPattern.test(cleanZipCode);
    if (isAllZeros) {
    this.fingerprintRegistrationForm.patchValue({
      city: '',
      state: ''
    });
    return;
  }
     let input = {
      smartyInd: false,
      zipcode: this.fingerprintRegistrationForm.get('zipCode')?.value
     }
      this.registrationService.smartyValidation(input).subscribe({
      next: response => {
        if(response.status === 'success'){
          if(response.data.length>0){
            this.fingerprintRegistrationForm.patchValue({
              city: response.data[0].zipcodes[0].default_city,
              state: response.data[0].zipcodes[0].state
            });
          }
        }
      }
    });
  }

  showConfirmRegModal(): void {
    this.showModal = true;
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 2000);
    setTimeout(() => {
      this.closeModal();
    }, 6000);
  }

  closeModal(): void {
    this.showModal = false;
  }

  openTermsAndConditionsModal(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        if (this.userAgreementContent) {
          this.showTermsAndConditionsModal();
          return;
        }

        
        this.registrationService.getUserAgreementContent(500, '2', 'FPV').subscribe({
          next: (response: any) => {
            if (response?.data?.length > 0) {
              const optionalData = response.data[0].optionaldata;
              if (optionalData) {
                try {
                  const parsed = typeof optionalData === 'string' ? JSON.parse(optionalData) : optionalData;
                  this.userAgreementContent = parsed?.content || '';
                } catch {
                  this.userAgreementContent = optionalData;
                }
              }
            }
            this.showTermsAndConditionsModal();
          },
          error: err => {
            console.error('Error loading user agreement content:', err);
            this.showTermsAndConditionsModal();
          }
        });
      }

      private showTermsAndConditionsModal(): void {
        this.matDialog.open(ContentManagementModalComponent, {
          width: '900px',
          disableClose: true,
          data: {
            heading: modalHeading.useragreementfp,
            content: this.userAgreementContent,
            buttons: [{ text: modalButtonTitles.close, class: 'btn-outline-primary' }]
          }
        });
      }

      openPrivacyPolicyModal(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        const options: NgbModalOptions = {
          backdrop: "static",
          centered: true,
          size: "lg"
        };

        this.customModal = this.ngModal.open(ModalComponent, options);

        const modalConfig: ModalConfig = {
          buttons: [
            { text: modalButtonTitles.close, code: 'N', btnOutline: false }
          ],
          heading: modalHeading.privacyPolicy,
          modalContent: modalContent.privacyPolicy,
          hasTemplate: true,
          scrollable: true
        };

        this.customModal.componentInstance.modalConfig = modalConfig;
      }
}
